import React from 'react';

import {
  MoneyFormat,
  OfferDescriptionWrapper,
  OfferPrice,
  Title,
} from '../elements';
import stripHtml from '../../utils/strip-html';
import { Offer, ProductVariant } from '../../types';
import { ProductOfferPricing } from '../ProductOfferPricing';
import OfferDescriptionContent from '../OfferBody/tree/OfferDescriptionContent';
import Badge from '../OfferBody/Badge';

interface Props {
  product: any;
  offer: Offer;
  variant?: ProductVariant;
  quantity: number;
}

const IGNORED_VARIANT_TITLE = 'Default Title';

export const TitleSection = ({ product, variant, quantity, offer }: Props) => {
  const { title, price, headline, short_description } = product;

  const renderVariantTitle = () =>
    offer.is_product &&
    variant?.title &&
    variant.title !== IGNORED_VARIANT_TITLE
      ? ` - ${variant.title}`
      : '';

  return (
    <>
      <Badge offer={offer} id={product.id} />
      <Title>{stripHtml(`${title || headline} ${renderVariantTitle()}`)}</Title>
      {variant ? (
        <ProductOfferPricing
          variant={variant}
          offer={offer}
          quantity={quantity}
        />
      ) : (
        <OfferPrice>
          <MoneyFormat
            amount={
              Number(price) * quantity * Number(window.Shopify.currency.rate)
            }
          />
        </OfferPrice>
      )}
      {short_description && (
        <OfferDescriptionWrapper>
          <OfferDescriptionContent>{short_description}</OfferDescriptionContent>
        </OfferDescriptionWrapper>
      )}
    </>
  );
};
